// Re-export everything from UserContext for backward compatibility
import { useUser, UserProvider } from "@/contexts/UserContext";

export { useUser, UserProvider };
export default useUser;